import { Link, Modal, Stack, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Helpers } from "../helpers/helpers";
import { useEffect, useState } from "react";
import { useContextWithGuard } from "../helpers/useContextWithGuard";
import { SettingsContext } from "../settings/settingsProvider";
import { useAnalytics } from "../firebase/firebase";
import { IQuestion } from "../types";
import { TiledBackground } from "../theme/background";
import { useTheme } from '@mui/material/styles';

interface DownloadPdfModalProps {
    open: boolean;
    setOpen: (b: boolean) => void;
    items: IQuestion[];
}

interface IPublishResult {
    status: string;
    url: string;
}

const MAX_ALLOWED_ITEMS = 25
export const DownloadPdfModal = (props: DownloadPdfModalProps) => {
    const { track } = useAnalytics();
    const [downloadUrl, setDownloadUrl] = useState<string | string[]>("");
    const [errored, setErrored] = useState<boolean>(false);
    const { publishPdfMode } = useContextWithGuard(SettingsContext, "SettingsContext");
    const theme = useTheme();

    useEffect(() => {
        setDownloadUrl("");
        setErrored(false);
        if (props.open &&
            props.items.length > 0 &&
            props.items.length <= MAX_ALLOWED_ITEMS) {
            Helpers.post<IPublishResult>(
                "https://question-salad-publisher-506073112941.europe-west1.run.app",
                {
                    items: props.items.map(i => {
                        return { "id": i.id, "collection": i.collection }
                    }),
                    mode: publishPdfMode
                }
            )
                .then((result: IPublishResult) => {
                    if (result.status !== "success") {
                        setErrored(true);
                    }
                    else {
                        setDownloadUrl(result.url);
                    }
                })
            track("downloadPdf", {
                items: props.items
            });
        }
    }, [props.open, JSON.stringify(props.items), publishPdfMode])

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90vw',                // Responsive width
        maxWidth: 400,                // Don’t exceed your original design
        maxHeight: '90vh',            // Prevent overflow on small screens
        background: theme.bee.barBackground,
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        overflow: "scroll",
    };

    return (
        <Modal
            open={props.open}
            onClose={() => props.setOpen(false)}
            aria-labelledby="publish pdf"
        >
            <Box sx={style}>

                <TiledBackground offset={0} />
                <Stack direction="column" spacing={2}>

                    <Typography variant="h5" sx={{ borderBottom: "solid 1px black" }}>
                        Download as PDF
                    </Typography>
                    {
                        props.items.length > MAX_ALLOWED_ITEMS
                            ?
                            <Typography id="oops" variant="h6" component="h2">
                                sorry you cannot publish more than 25 questions at once...
                            </Typography>
                            :
                            errored
                                ?
                                <Typography id="oops" variant="h6" component="h2">
                                    oh dear something went wrong...
                                </Typography>
                                :
                                downloadUrl
                                    ?
                                    publishPdfMode == "combined"
                                        ?
                                        <>
                                            Success!
                                            <br />
                                            <Link href={downloadUrl as string} target="_blank">
                                                Click here to download
                                            </Link>
                                        </>
                                        :
                                        <>
                                            Success!
                                            <br />
                                            <Link href={downloadUrl[0]} target="_blank">
                                                Click here to download questions
                                            </Link>
                                            <br />
                                            <Link href={downloadUrl[1]} target="_blank">
                                                Click here to download solutions
                                            </Link>
                                        </>
                                    :
                                    <Typography id="creating" variant="h6" component="h2">
                                        Creating pdf...
                                    </Typography>
                    }
                </Stack>
            </Box>
        </Modal>
    )
}